export const isProd = import.meta.env.PROD;
window.PRODUCTION_BUILD = isProd;

export function isProdHostname() {
  const prodHostnames = ["przezmorze-pl.firebaseapp.com", "b2b.przezmorze.pl"];
  return prodHostnames.includes(location.hostname);
}
